<template>
  <!--  字段权限-->
  <div class="fields-privilege">
    <div v-if="!sheet.controls || sheet.controls.length == 0" class="empty">
      无字段可编辑
    </div>
    <el-table
      v-else
      v-ps="'.el-table__body-wrapper'"
      :data="fieldPrisList"
      :header-cell-style="headerStyle"
      :highlight-current-row="false"
      :cell-style="{ height: '40px' }"
      :max-height="screenHeight"
    >
      <el-table-column label="字段" prop="name" width="458px"></el-table-column>
      <el-table-column prop="fieldPris.R" width="230px">
        <!--        列表头的复选框-->
        <!--         eslint-disable-next-line-->
        <template slot="header" slot-scope="scope">
          <el-checkbox
            label="查看"
            :value="fieldPris_all.R"
            :indeterminate="fieldPris_all.R_indeterminate"
            @change="setAll('R', $event)"
          ></el-checkbox>
        </template>
        <!--        列表项的复选框-->
        <template slot-scope="scope">
          <el-checkbox :value="scope.row.R" @change="changeSelectR($event, scope)"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column prop="fieldPris.RW" width="230px">
        <!--        列表头的复选框-->
        <!--         eslint-disable-next-line-->
        <template slot="header" slot-scope="scope">
          <el-checkbox
            label="编辑"
            :value="fieldPris_all.RW"
            :indeterminate="fieldPris_all.RW_indeterminate"
            @change="setAll('RW', $event)"
          ></el-checkbox>
        </template>
        <!--        scope包含index、column、row、store、_self的回调函数信息-->
        <!--        列表项的复选框-->
        <template slot-scope="scope">
          <el-checkbox :value="scope.row.RW" @change="changeSelectRW($event, scope)"></el-checkbox>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "fields-setting",
  props: {
    sheet: Object,
    fieldPrisMap: Object
  },
  data() {
    return {
      fieldPris_all: {
        R: true, // 全部选中为true
        R_indeterminate: false, // 有选中但不是全部选中为true
        RW: true,
        RW_indeterminate: false
      },
      screenHeight: `${document.documentElement.clientHeight}` - 286,
      fieldPrisList: [],
      headerStyle: {
        color: "#333",
        backgroundColor: "#ededed"
      }
    }
  },
  watch: {
    fieldPrisList: {
      handler() {
        this.setFieldPris_all()
      },
      deep: true
    }
  },
  mounted() {
    const that = this
    window.onresize = function listen() {
      that.screenHeight = `${document.documentElement.clientHeight}` - 286
    }
  },
  methods: {
    // 初始化
    initial() {
      this.initialFieldPris()
    },
    changeSelectRW(ischecked, scope) {
      if (ischecked) {
        scope.row.RW = true
        scope.row.R = true
      } else {
        scope.row.RW = false
      }
    },
    changeSelectR(ischecked, scope) {
      if (ischecked) {
        scope.row.R = true
      } else {
        scope.row.R = false
        scope.row.RW = false
      }
    },
    // 更新字段权限的fieldPris_all
    setFieldPris_all() {
      let length = Object.keys(this.fieldPrisList).length
      let count_R = 0,
        count_RW = 0
      // 每当fieldPris为true时，相应的count++
      for (let key in this.fieldPrisList) {
        if (this.fieldPrisList[key].R) count_R++
        if (this.fieldPrisList[key].RW) count_RW++
      }
      // 如果有选中但是长度和fieldPris不相等的话，就不是全部选中了，R_indeterminate为真
      if (count_R && count_R != length) this.fieldPris_all.R_indeterminate = true
      else this.fieldPris_all.R_indeterminate = false
      this.fieldPris_all.R = count_R == length
      if (count_RW && count_RW != length) this.fieldPris_all.RW_indeterminate = true
      else this.fieldPris_all.RW_indeterminate = false
      this.fieldPris_all.RW = count_RW == length
    },
    // 初始化字段权限
    initialFieldPris() {
      // 初始化前进行一个赋值操作
      let fieldPrisList = []
      // 累加器获取字段权限，acc累加结果，cur代表当前值。将cur都用传来的fieldPrisMap函数处理一下获取权限的字段，然后把name和权限累加给acc
      // 最终变为一个包含name和其权限的对象，并拷贝给this.fieldPris
      fieldPrisList = this.sheet.controls.reduce((acc, cur) => {
        if (!this.fieldPrisMap[cur._cid] || this.fieldPrisMap[cur._cid] == "RW") {
          acc[cur._cid] = {
            R: true,
            RW: true
          }
        } else if (this.fieldPrisMap[cur._cid] == "R") {
          acc[cur._cid] = {
            R: true,
            RW: false
          }
          this.fieldPris_all.RW = false
        } else if (this.fieldPrisMap[cur._cid] == "N") {
          acc[cur._cid] = {
            R: false,
            RW: false
          }
          this.fieldPris_all.R = false
        }
        acc[cur._cid].name = cur.name
        acc[cur._cid].id = cur._cid
        return acc
      }, {})
      this.fieldPrisList = Object.values(fieldPrisList)
    },
    // 选中字段权限顶部的设置全部，当设置所有RW权限为true时，所有R权限也要设为true；
    // 编辑（RW）必能查看（R），不查看必不能编辑
    // 当设置所有R权限为false时，所有RW权限也要设为false
    setAll(type, checked) {
      let setAllType = this.getSetAllType(type, checked)
      for (let key in this.fieldPrisList) {
        switch (setAllType) {
          case "Set_R_True": {
            Object.assign(this.fieldPrisList[key], { R: true, RW: true })
            break
          }
          case "Set_RW_False": {
            Object.assign(this.fieldPrisList[key], { R: false, RW: false })
            break
          }
          case "default": {
            this.fieldPrisList[key][type] = checked
            break
          }
        }
      }
    },
    // 获取设置全部的类型，Set_R_True 代表所有 R 权限也要设为 true；
    // Set_RW_False 代表所有 RW 权限也要设为 false；default 代表仅设置所有 R 或 RW 权限为 true
    getSetAllType(type, checked) {
      let setAllType = "default"
      if (type == "RW" && checked) setAllType = "Set_R_True"
      else if (type == "R" && !checked) setAllType = "Set_RW_False"
      return setAllType
    },
    // 输出字段权限
    output() {
      // key 应该就是_cid
      let output = {}
      this.fieldPris = this._.keyBy(this.fieldPrisList, "id")
      for (let key in this.fieldPris) {
        let result = "N"
        if (this.fieldPris[key].R) result = "R"
        if (this.fieldPris[key].RW) result = "RW"
        output[key] = result
      }
      return output
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-table::before {
    background: none;
  }
  .ps__thumb-x {
    display: none !important;
  }
}
</style>
